import React from 'react';
import type {
  Control,
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
} from 'react-hook-form';
import { Controller } from 'react-hook-form';

import useFormContext from '../../form/useFormContext';

interface FieldProps {
  name: string;
  error?: boolean;
  helperText?: React.ReactNode;
  onBlur?: (e: unknown) => void;
  [key: string]: unknown;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createField(Component: React.ComponentType<any>) {
  function Wrapper(props: FieldProps) {
    const { name, error = false, helperText, ...restProps } = props;
    const { control } = useFormContext() as { control: Control<FieldValues> };

    const renderField = ({
      field,
      fieldState,
    }: {
      field: ControllerRenderProps;
      fieldState: ControllerFieldState;
    }) => {

      const handleOnBlur = (e: unknown) => {
        field.onBlur();
        const { onBlur } = restProps;
        if (onBlur) {
          onBlur(e);
        }
      };

      const props = {
        error: Boolean(fieldState.error) || error,
        helperText: fieldState.error?.message || helperText,
        ...restProps,
        ...field,
        onBlur: handleOnBlur,
      };

      return React.createElement(Component, props);
    };

    return <Controller name={name} control={control} render={renderField} />;
  }

  Wrapper.displayName = `${Component.displayName}(Generic)`;
  return Wrapper;
}

export default createField;
